//import { selectProperties } from "@fluentui/react";
import React from "react";

class ArchivePeriodDropdown extends React.Component {
  constructor() {
    super();
    this.state = {
      selectedOption: "",
      isConfirmed: false,
    };
  }

  handleOptionChange = (event) => {
    const value = event.target.value;
    this.setState({ selectedOption: value });
    this.props.onChangeDropDown(value);
    if (value === "1" || value === "2") {
      this.setState({ isConfirmed: false });
    }
  };

  handleConfirmedChange = (event) => {
    const checked = event.target.checked;
    this.setState({ isConfirmed: checked });
    this.props.onChangeCheckBox(checked);
  };

  render() {
    const isCheckboxVisible =
      this.state.selectedOption === "5" || this.state.selectedOption === "10";

    return (
      <div style={{ textAlign: "right" }}>
        <label htmlFor="combo-box">Select an archive period: </label>
        <select
          id="combo-box"
          value={this.state.selectedOption}
          onChange={this.handleOptionChange}
          style={dropDownStyle}>
          <option value="1" style={dropDownOptionStyle}>
            1 year
          </option>
          <option value="2" style={dropDownOptionStyle}>
            2 years
          </option>
          <option value="5" style={dropDownOptionStyle}>
            5 years
          </option>
          <option value="10" style={dropDownOptionStyle}>
            10 years
          </option>
        </select>

        {isCheckboxVisible && (
          <div style={{ marginTop: "10px" }}>
            <input
              type="checkbox"
              id="confirm-checkbox"
              checked={this.state.isConfirmed}
              onChange={this.handleConfirmedChange}
            />
            <label htmlFor="confirm-checkbox">
              I confirm that this site/team must be archived long-term for legal
              reasons, audit requirements or sensitive/strategically relevant
              business reasons.
            </label>
          </div>
        )}
      </div>
    );
  }
}

const dropDownStyle = {
  fontWeight: "400",
  border: "1px solid rgb(138,136,134)",
  display: "inline-block",
  textAlign: "center",
  padding: "0px 16px",
  borderRadius: "2px",
  height: "32px",
  color: "rgb(50, 49, 48)",
  backgroundColor: "rgb(255, 255, 255)",
};

const dropDownOptionStyle = {
  textAlign: "center",
  fontSize: "14px",
  fontFamily: "Abb Inside",
};

export default ArchivePeriodDropdown;



// WEBPACK FOOTER //
// ./src/components/CustomComponents/ArchivePeriodDropdown.js